<template>
  <section class="container">
    <section class="panel center-block">
      <div class="container-fluid">
        <h1 class="sep mt-3">Crédits</h1>
        <div class="embed-responsive embed-responsive-1by1" style="height:905px">
          <iframe class="embed-responsive-item" src="https://www.goweb.fr/credits"></iframe>
        </div>
        <p class="text-center mt-4"><a class="btn btn-primary" href="javascript:void(0)" v-on:click="GoToQuestion">Question of the day</a></p>

      </div>
    </section><!-- PANEL -->
    <span class="panel-bottom"></span>
  </section><!-- CONTAINER FLUID-->
</template>
<script>
  import $ from 'jquery';
  import { Utility } from '../configs/configpaths';
  export default {
    mounted: function () {
      var _self = this;
      _self.$parent.GloablEvents();

    },
    methods: {
      GoToQuestion: function () {
        var _self = this;

        var CURRENT_USER = Utility.GetCurrent();
        var TOKEN = Utility.GetToken();
        if (!CURRENT_USER) {

          _self.$router.push('/');
        }


        if (!CURRENT_USER.QuestionId) {
          _self.$router.push('/ListeQuestions/');
          return;
        }
        var settings = {
          "crossDomain": true,
          "url": _self.BASE_URL + "api/question/Statut",
          "data": {
            "id": parseInt(CURRENT_USER.QuestionId),
            "participant": parseInt(CURRENT_USER.Id),
            "isTesteur": CURRENT_USER.Role === "TESTEUR"
          },
          "method": "GET",
          "headers": {
            'Authorization': 'Bearer ' + TOKEN
          }
        };

        $.ajax(settings).done(function (response) {

          if (response === true) {
            _self.$router.push('/DejaJoue/' + parseInt(CURRENT_USER.QuestionId));
          } else {
            _self.GetQuestion();
          }

        });
      },
      GetQuestion: function () {
        var _self = this;
        var CURRENT_USER = Utility.GetCurrent();
        var TOKEN = Utility.GetToken();
        if (!CURRENT_USER) {
          _self.$router.push('/');
          return;
        }

        if (!CURRENT_USER.QuestionId) {
          _self.$router.push('/ListeQuestions/');
          return;
        }
        var settings = {
          "crossDomain": true,
          "url": _self.BASE_URL + "api/question/item",
          "data": {
            "id": parseInt(CURRENT_USER.QuestionId),
            "participant": parseInt(CURRENT_USER.Id),
          },
          "method": "GET",
          "headers": {
            'Authorization': 'Bearer ' + TOKEN
          }
        };

        $.ajax(settings).done(function (response) {
          _self.QUESTION = response;
          _self.$parent.initCountDown(_self.QUESTION.DelaiReponse * 60, _self.QUESTION.NombredePoints);

        });
      },
    }

  }
</script>
<style lang="scss" scoped>

</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
